import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store.js'
import {mixin, elementPlusLocale} from '@f1/upc-webapp-ui-vue3'
import elementplus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {i18n} from './i18n.js'
import mainAuth from './auth'
import axios from './http-common'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import './assets/css/main.css';

const init = (mainAuth) => {
    const app = createApp(App)
    if (mainAuth != null) {
        app.config.globalProperties.$oidc = mainAuth
        app.provide('$oidc', mainAuth); 

        // Afegir token autentificació
        axios.interceptors.request.use(function (config) {
            if (!config.url.startsWith("http") && mainAuth.user != null) {
                config.headers.Authorization =  "Bearer " + mainAuth.user.id_token;
            }
            return config;
        });
    }

    app.use(elementplus, {locale: elementPlusLocale})
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
    }
    app.use(i18n)
    app.mixin({...mixin})
    app.use(router)
    app.use(store)

    app.use(VueReCaptcha, {
        siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
        loaderOptions: {
            autoHideBadge: true,
            renderParameters: {
                badge: 'bottomright'
            }  
        }
      })

    app.mount('#app')
    return app
}

if (window.auth) {
    mainAuth.useRouter(router)
    mainAuth.startup().then(success => {
        if (success) {
            init(mainAuth)
        } else {
            console.log('Startup was not ok')
        }
    })
} else {
    init(null)
}
